module.exports = __webpack_public_path__ + "img/89a0477.png";